import * as React from 'react';
import {Pie, PieChart, ResponsiveContainer} from 'recharts';
import {Card, CardBody, Col} from 'reactstrap';
import AccountMultipleOutlineIcon from 'mdi-react/AccountMultipleOutlineIcon';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {localNumber} from '../../../../utils/number-utils';
import {setCarteraDetalle} from '../../../../reduxstore/actions/action-creators';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {IFuerzaVenta} from '../../../../utils/constants';

interface CarteraDetalleWidgetProps {
    carteraDetalle: mirana.CarteraDetalle;
    fuerzaVenta: IFuerzaVenta;
    dispatch: (action: any) => (any);
}

interface CarteraDetalleWidgetState {
    carteraTotal: number;
    noAtendidos: number;
    fechaConsulta: string;
}

const mapStateToProps = (state, ownProps) => {
    const carterasDetalles = state.app.getCarterasDetalles();
    return {
        carteraDetalle: carterasDetalles.get(ownProps.fuerzaVenta.id)
    };
};

class CarteraDetalleWidget extends React.PureComponent<CarteraDetalleWidgetProps, CarteraDetalleWidgetState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props) {
        super(props);
        this.state = {
            carteraTotal: 0,
            noAtendidos: 0,
            fechaConsulta: ''
        }
    }

    public async componentWillMount() {
        const response = await this.apiClient.obtenerCarteraDetalle(this.props.fuerzaVenta.id);
        this.props.dispatch(setCarteraDetalle(response, this.props.fuerzaVenta.id));
    }

    public componentWillReceiveProps(props) {
        this.setState({
            carteraTotal: props.carteraDetalle.carteraTotal,
            noAtendidos: props.carteraDetalle.noAtendidos,
            fechaConsulta: props.carteraDetalle.fechaConsulta
        });
    }

    public get pieData() {
        const data: any[] = [];
        const clientesAtendidos = this.state.carteraTotal - this.state.noAtendidos;
        data.push({value: this.state.noAtendidos, fill: '#ff4861'});
        data.push({value: clientesAtendidos, fill: '#eeeeee'});
        return data;
    }

    public render() {
        return (
            <Col md={12} xl={3} lg={6} sm={12} xs={12}>
                <Card>
                    <CardBody className='dashboard__health-chart-card'>
                        <div className='card__title'>
                            <h5 className='bold-text'>Clientes No Atendidos - {this.props.fuerzaVenta.descripcion}</h5>
                        </div>
                        <div className='dashboard__health-chart'>
                            <ResponsiveContainer height={235}>
                                <PieChart>
                                    <Pie data={this.pieData} dataKey='value' cy={110} innerRadius={100}
                                         outerRadius={110}/>
                                </PieChart>
                            </ResponsiveContainer>
                            <div className='dashboard__health-chart-info'>
                                <AccountMultipleOutlineIcon style={{fill: '#ff4861'}}/>
                                <p className='dashboard__health-chart-number'>{localNumber(this.state.noAtendidos)}</p>
                                <p className='dashboard__health-chart-units'>Al {this.state.fechaConsulta}</p>
                            </div>
                        </div>
                        <p className='dashboard__goal'>Cartera Total: {localNumber(this.state.carteraTotal)}</p>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

export default connect(mapStateToProps)(CarteraDetalleWidget);


// WEBPACK FOOTER //
// ./src/components/pages/portada/widgets/cartera-detalle-widget.tsx